import React, { lazy } from 'react';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
const Contact = () => {
  return <div className="bg-[#f8f9f4] min-h-screen w-full" data-id="element-818">
      {/* Hero section */}
      <div className="bg-[#2e7d32] text-white py-16" data-id="element-819">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-820">
          <h1 className="text-4xl font-bold mb-4" data-id="element-821">Contact Us</h1>
          <p className="text-lg max-w-2xl mx-auto" data-id="element-822">
            We'd love to hear from you. Reach out to us with any questions about
            our products or services.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-823">
        <div className="max-w-6xl mx-auto" data-id="element-824">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-825">
            {/* Contact information */}
            <div data-id="element-826">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-827">
                Get in Touch
              </h2>
              <p className="text-gray-600 mb-8" data-id="element-828">
                Have questions about our products or need assistance with your
                order? Our team is here to help. Contact us through any of the
                channels below.
              </p>
              <div className="bg-white rounded-xl shadow-md p-8 space-y-6" data-id="element-829">
                <div className="flex items-start" data-id="element-830">
                  <div className="bg-[#e8f5e9] p-3 rounded-full mr-4" data-id="element-831">
                    <MapPin className="h-6 w-6 text-[#2e7d32]" data-id="element-832" />
                  </div>
                  <div data-id="element-833">
                    <h3 className="font-semibold text-gray-900" data-id="element-834">
                      Our Location
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-835">
                      123 Kenyatta Avenue, Nairobi, Kenya
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-836">
                  <div className="bg-[#e8f5e9] p-3 rounded-full mr-4" data-id="element-837">
                    <Phone className="h-6 w-6 text-[#2e7d32]" data-id="element-838" />
                  </div>
                  <div data-id="element-839">
                    <h3 className="font-semibold text-gray-900" data-id="element-840">
                      Phone Number
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-841">+254 700 123 456</p>
                    <p className="text-gray-600" data-id="element-842">+254 733 987 654</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-843">
                  <div className="bg-[#e8f5e9] p-3 rounded-full mr-4" data-id="element-844">
                    <Mail className="h-6 w-6 text-[#2e7d32]" data-id="element-845" />
                  </div>
                  <div data-id="element-846">
                    <h3 className="font-semibold text-gray-900" data-id="element-847">
                      Email Address
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-848">info@shiriakaoils.com</p>
                    <p className="text-gray-600" data-id="element-849">support@shiriakaoils.com</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-850">
                  <div className="bg-[#e8f5e9] p-3 rounded-full mr-4" data-id="element-851">
                    <Clock className="h-6 w-6 text-[#2e7d32]" data-id="element-852" />
                  </div>
                  <div data-id="element-853">
                    <h3 className="font-semibold text-gray-900" data-id="element-854">
                      Business Hours
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-855">
                      Monday - Friday: 9am - 6pm
                    </p>
                    <p className="text-gray-600" data-id="element-856">Saturday: 10am - 4pm</p>
                    <p className="text-gray-600" data-id="element-857">Sunday: Closed</p>
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-858">
                <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-859">
                  Follow Us
                </h3>
                <div className="flex space-x-4" data-id="element-860">
                  <a href="#" className="bg-[#e8f5e9] p-3 rounded-full text-[#2e7d32] hover:bg-[#2e7d32] hover:text-white transition-colors duration-300" data-id="element-861">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-862">
                      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" data-id="element-863" />
                    </svg>
                  </a>
                  <a href="#" className="bg-[#e8f5e9] p-3 rounded-full text-[#2e7d32] hover:bg-[#2e7d32] hover:text-white transition-colors duration-300" data-id="element-864">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-865">
                      <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.045-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" data-id="element-866" />
                    </svg>
                  </a>
                  <a href="#" className="bg-[#e8f5e9] p-3 rounded-full text-[#2e7d32] hover:bg-[#2e7d32] hover:text-white transition-colors duration-300" data-id="element-867">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-868">
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-869" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            {/* Contact form */}
            <div data-id="element-870">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-871">
                Send Us a Message
              </h2>
              <p className="text-gray-600 mb-8" data-id="element-872">
                Fill out the form below and we'll get back to you as soon as
                possible.
              </p>
              <form className="bg-white rounded-xl shadow-md p-8" data-id="element-873">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-874">
                  <div data-id="element-875">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-876">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" placeholder="Your first name" data-id="element-877" />
                  </div>
                  <div data-id="element-878">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-879">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" placeholder="Your last name" data-id="element-880" />
                  </div>
                </div>
                <div className="mb-6" data-id="element-881">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-882">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" placeholder="your@email.com" data-id="element-883" />
                </div>
                <div className="mb-6" data-id="element-884">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-885">
                    Phone Number (Optional)
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" placeholder="+254 7XX XXX XXX" data-id="element-886" />
                </div>
                <div className="mb-6" data-id="element-887">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-888">
                    Subject
                  </label>
                  <input type="text" id="subject" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" placeholder="How can we help you?" data-id="element-889" />
                </div>
                <div className="mb-6" data-id="element-890">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-891">
                    Message
                  </label>
                  <textarea id="message" rows={5} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-[#2e7d32] focus:border-[#2e7d32] outline-none" placeholder="Your message here..." data-id="element-892"></textarea>
                </div>
                <button type="submit" className="w-full bg-[#2e7d32] hover:bg-[#1b5e20] text-white py-3 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center" data-id="element-893">
                  <Send className="h-5 w-5 mr-2" data-id="element-894" />
                  Send Message
                </button>
              </form>
            </div>
          </div>
          {/* Map section */}
          <div className="mt-16" data-id="element-895">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-896">
              Visit Our Store
            </h2>
            <div className="bg-white rounded-xl shadow-md overflow-hidden h-96" data-id="element-897">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15955.277444357472!2d36.81982433955077!3d-1.2833361999999908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f10d22f318f3d%3A0x1d3d6d5b0a1c6c37!2sKenyatta%20International%20Convention%20Centre!5e0!3m2!1sen!2ske!4v1626345601845!5m2!1sen!2ske" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" title="Store Location" data-id="element-898"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Contact;